// src/components/Subscription/SubscriptionCancel.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import { AlertCircle } from 'lucide-react';
import SubscriptionPromo from './SubscriptionPromo';
import agthealthService from '../../services/agthealthService';

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const [showSubscription, setShowSubscription] = useState(false);
  
  const handleLogout = async () => {
    try {
      // Llamar al servicio de logout para limpiar cualquier estado en el servidor
      await agthealthService.logout();
      
      // Eliminar el token de autenticación y cualquier otra información de sesión
      localStorage.removeItem('agthealth_token');
      sessionStorage.clear(); // Limpiar cualquier dato en sessionStorage
      
      // Forzar la recarga de la página para asegurar que todo el estado se reinicie
      window.location.href = '/login';
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      // En caso de error, intentar el método de respaldo
      localStorage.removeItem('agthealth_token');
      window.location.href = '/login';
    }
  };

  if (showSubscription) {
    return <SubscriptionPromo onClose={() => setShowSubscription(false)} />;
  }
  
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      p: 2
    }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, width: '100%', textAlign: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <AlertCircle size={60} color="#f44336" style={{ marginBottom: 16 }} />
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Suscripción Cancelada
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Has cancelado el proceso de suscripción. Necesitas una suscripción activa para acceder a todas las funcionalidades de AGT Health.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Sin una suscripción activa, no podrás acceder al dashboard y las funcionalidades completas.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              variant="outlined" 
              onClick={handleLogout}
            >
              Cerrar Sesión
            </Button>
            <Button 
              variant="contained" 
              onClick={() => setShowSubscription(true)}
              color="primary"
            >
              Suscribirse Ahora
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionCancel;